
export type LikeProject200 = {
  code?: string;
  message?: string;
  success?: boolean;
};
